import React from "react";
import styles from "./saveAndContinueButton.scss";

export interface SaveAndContinueButtonProps {
  onClick: (event) => void;
  disabled?: boolean;
}

const SaveAndContinueButton = (props: SaveAndContinueButtonProps): JSX.Element => {
  const { onClick, disabled } = props;
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
    >
      Spremi i nastavi kasnije
    </button>
  );
};

SaveAndContinueButton.defaultProps = {
  disabled: false,
};

export default SaveAndContinueButton;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepFooter/SaveAndContinueButton/index.tsx